/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S2_Li4Inputs */

const en_guide_what_is_json_s2_li4 = /** @type {(inputs: Guide_What_Is_Json_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Null</strong>: Represents empty or missing data: <code>null</code>`)
};

const ko_guide_what_is_json_s2_li4 = /** @type {(inputs: Guide_What_Is_Json_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Null</strong>: 비어 있거나 누락된 데이터를 나타냄: <code>null</code>`)
};

const ja_guide_what_is_json_s2_li4 = /** @type {(inputs: Guide_What_Is_Json_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Null</strong>: 空またはデータなしを表す：<code>null</code>`)
};

/**
* | output |
* | --- |
* | "<strong>Null</strong>: Represents empty or missing data: <code>null</code>" |
*
* @param {Guide_What_Is_Json_S2_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s2_li4 = /** @type {((inputs?: Guide_What_Is_Json_S2_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S2_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s2_li4(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s2_li4(inputs)
	return ja_guide_what_is_json_s2_li4(inputs)
});